import { arbitrumGoerli, zkSyncTestnet } from 'wagmi/chains'

export const getChainId = ()=>{
  return window.location.href.includes('zks') ? zkSyncTestnet : arbitrumGoerli
}

export const masacAddress = str => str.substring(0, 4) + '...' + str.substr(-4)

export function numberWithCommas(x, len = 2) {
  if(x > 1000) return Number(x).toFixed(len).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return Number(x).toFixed(2)
}

function getResult(a, digit) {
  return (Math.floor(a * 10 ** (digit + 2)) / (10 ** (digit + 2))).toFixed(digit + 2)
}

export const toFixed = (x, fixedNum = 3) => {  
if(x == 0 || !x){
    return '0.00'
  }

  if (Math.abs(x) < 1.0) {    
    var e = parseInt(x.toString().split('e-')[1]);
    if (e) {
        x *= Math.pow(10,e-1);
        x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
    }else{
      let str = x.toString().split('.')[1];
      let match = str.match(/[1-9]/);      
      if (match) {
        let index = match.index;
        let str = x.toString().slice(index + 2 , index + fixedNum + 2)
        let strFormat = `0.${Array(index).fill(0).join('')}${str}`
        strFormat = `${strFormat.replace(/(?<!\.)0+$/,'')}`
        return strFormat
      } else {
        
      }
    }
  } else {
    var e = parseInt(x.toString().split('+')[1]);    
    if (e > 20) {
        e -= 20;
        x /= Math.pow(10,e);
        x += (new Array(e+1)).join('0');
    }else{
      const r = getResult(+x, fixedNum).replace(/(?<!\.)0+$/,'')
      return r
    }
  }
  return x;
}

export const whiteList = [
    // first
  '0x3a121Fb7CA135Ea7b7029d5dc2198c90f005C60c',
  '0x5c246808E34629098651793d3fB79f413Cb67425',
  '0xb8E9f05beA1d82e1E4Aa79DD60D9065d1Bc0cAcC',
  '0xC6eDc770fcaf2d80506A7ba96354d2DFAdEb6D0F',
  '0x72C9e6cB9BCD28d65c71e61f72Bee1790b567127',
  '0x2f75442ebe16D80C7A4f642862E3B3CEe47E5B54',
  '0x047AE38BEC9Cd1e36Ce664b953D1a71e6c29f195',
  '0xb8f186Ea08b8Fe0Dd4d46EB6103093e107C11555',
  '0xC0e450341f6339e6584BCdD237b5b6535F9785E9',
  '0x5e729af81e88a21895ac83400adDd2F2078c6A00',
  '0x570F9a34c2201283D21fDA5AF074B413Fe12069A',
  '0x61E5ab355B98ED4055282C1AC5d5cF738BCdd630',
  '0x7A34E75dc07d917CfeFA65D9BCfCAf2B25C52380',
  '0x7Fa6eD463c00A8e3772B8279feAD0de287cb972c',
  '0x2b21e04509583eBbf2D7fFBE013F6cba6b6ba605',
  '0x8371ddeBeCD729Bfb14e4aB7D4aB2bAaDF79A4BF',
  '0x99095B01f51c73b143b487669488E220Fc16EA44',
  '0x3af6eE1834eBB7e3ff368Ebb33d087F5CCe878D8',
  '0x6591C24a7f7d3B37527487a457b2f467936DFE59',
  '0x443cc1CeF791BC08791a06dE35fC551c13cAD50d',
  '0x4CACB9a2065bE7bbFF87Ce9e8ee65A8CEC0D3593',
  '0x4a7f1Df9b2C3801198AC7c28c93a4273b821D2d0',
  '0x61aE6Ce1F83b79CA28dbfA732f41811d63E95966',
  '0x912F718466A190E0511e86F56CC6CD889f912a4C',
  '0xd50d47F0ae102aD9F6Aa18f187a6cAD3DC42AFc9',
  '0xe88c24b71d8463E4c84f63155F2477Ebcd0F65BF',
  '0xF7A819DEBA0d69C4f3567cb9fAc04B05Ec3A6516',
  '0xE0D3dC4Ad4d4974084BcC108Eb4292D6113EdC45',
  '0x8221F1AD11011EfB5A61b674756193B455ffd87D',
  '0x517b5082f6e13d9aecc1791ccb0cb58b2484a8a0',
  '0xCD31BA0842B9FDd628CA334ABAF0Cb03ec01d333',
  '0x3e698f0Dbe28a74dBdBC451cF9D0EDdEe862d734',
  
  '0x299667e0B886bc54b74C6229730c2AA6082c9AF3',
  '0x432d5a60721337e67f67f5d198D9585Cf995419f',
  '0x3F16324623eAe60271f624D7c16637Ea9ac08b4B',
  '0xF1fdAa157a9C7943692171c95B8F73C8c2Fd655F',
  '0xCE4Dfb3A4E053dcbb931f5ED5fB15F1E07955f9b',
  '0x99095B01f51c73b143b487669488E220Fc16EA44',
  '0x382827268EfD1a65e391F058CdcA9c082A3B9Df2',
  '0x6867B29F8AF0674b660E210Db55752D53aBF05B7',
  '0x00000034052862A6F264cFA365191822aBE146Fd',
  '0xAB5971dDA9F26c88Ff357c60Fce2e2270AA47857',
  '0xF75bcFA2c0361C5589D671FD9490Ca83EF829cd9',
  '0x299f3e6838d493Be30CAa0a42b82402B2118A4f9',
  '0x42c83e3B740c077488A03717A1c12a9C4d786357',
  '0x71E89867d5Ae324e2848e7e53578f407b1e7A65e',
  '0x3510Dd722560F6EdF37F252F5A151E4cE0b45622',
  '0xF1F1B08DbE82398352C22A0Effc2c713dD566EDd',

  '0x75a8b8C2BeA5C6E71E4ff7a2238D688D233D42A9',
  '0x2E01226C64DEf741AD7911AAB518aD4162e105eb',

  // second
  '0xC31f32680Ccb81932DDC06B4507863508113506E',
  '0x7DC6a4114e13E25f53B720ec453E13FB83f7bA6d',
  '0x6Ae313D472e753206b948A86dCd1cDFa97de4fc7',
  '0x0655867208a744e0feb1d75653366a9E7ccBB4d2',
  '0xAB5971dDA9F26c88Ff357c60Fce2e2270AA47857',
  '0x2D10F522CF9910e8a81dAc2063c211fC1B6d93Ef',
  '0xFef9bC6DDe7a73A5913cFa3B916d0ad918B27E93',
  '0x4183D5cA97E324f036265e189099cd287C6D45aD',
  '0xd8AbcAf356A89Edb675517666aEF64D2313C4Fda',
  '0x0000040f1111c5C3d2037940658Ee770BB37e0a2',
  '0xb53F88f03073a7BEdEf259caD025DeACb808eeCc',
  '0x3aba3AAb97accFBB51B2e97186ED647775352878',
  '0xFbB90EeCF81E404673304a9F8c4bA156a76018F0',
  '0x8F22c5b2a009AdeBe12E0F495C246736A09b5272',
  '0x000000D48Ca01537870667053A0c416873e3B2C1',
  '0x86CaCBFAb0322a09C46569BB187ae9feC24e55a6',
  '0xd4bff2Ec56cF207c08CdA4177b1AFAA89a11401a',
  '0x8221F1AD11011EfB5A61b674756193B455ffd87D',
  '0x99095B01f51c73b143b487669488E220Fc16EA44',
  '0x716C22DA796e1295154afBdc814757dF03c60807',
  '0x81c8Ede5B6a3dd3E198De88c297655987EA172eC',
  '0x6c7Ac736A6e597fD29513Cd37B7BAf238F4D89f2',
  '0x167480A441B9A0db3a315ad47726889B53503Df9',
  '0x15cF1A1bDb9d66ec90cD507CBC38422700e69Bf1',
  '0xE8363789e5e0d2E8Ef07F0314A870e4A5139a57b',
  '0x133C1B00620A48C39f5c1f9d8b53c627352d00F9',
  '0x856831B02Ae0a68A6115BD12b2d1b25B4698E968',
  '0x8Af7922167700185152bcF98010E793910c62CA8',
  '0xB22308A0b14aeE7710BAD1e7cE65492dd227eA28',
  '0x7Ed5D3481E0B9254F9d3Cda296933C21d4ec8eeB',
  '0xd069C4A5B6B65a292db96883f8F1198bdd42bc82',
  '0x3a6d7Ac6dba8121206C387ca23d3716C7e304861',
  '0xBAF7e3495F76a485246d683A59018F76aBAc391D',
  '0xc2325F748AebCb87e07112B022315c02169043BF',
  '0x0e7aB42c4774cc165E927459ed2439aD6a248DB6',
  '0x4ada7eEB8D4b619B85d929290651ee12b1BF84c8',
  '0xE008Da267134155b0968F140c45b47CaFCAeAa32',
  '0xA9c5531AE739c7edE4870eda7912a1dfba844055',
  '0xe9323E51c02F0E354C9A945C376b0cc75f6b1Cfa',
  '0xa5E94962F4774a67bD3725C7AB32343f1B992155',
  '0x6E04b03E5534e209626E0dbf408Ac92EBF800492',
  '0x9447897eE7d4a54d545387cda32EAd49d0c7c3b7',
  '0x9447897eE7d4a54d545387cda32EAd49d0c7c3b7',
  '0x15AF01BA86905248FB202d208Fd5f2772e4351d4',
  '0xf6bacfA5BB84429AEDDACF6860f69274e3C11832',
  '0x9C7ddA069B3dA04754812aA437C5939E4c30e1DC',
  '0xb6F54E577d3897D20289A19ce6385b0FD7E3762c',
  '0x4fcC2c1A6476DDc96FDE90010Dc1640AB8114375',
  '0x4b4c9D9EaDB8a551dc752975abD9Cc231a9097e7',
  '0x432d5a60721337e67f67f5d198D9585Cf995419f',
  '0x7ee4b2E1257802Ae55934Aa5eCe0D7B66ec7Dc39',
  '0x24a84fAd1D9112eF0A53a3D58216E84a50B4E813',
  '0x586632EF8c937a8877B06E3634c04Cb7B14E8dDd',
  '0xcfd7BaDaCC953D2a758073864669f2f107f66b5b',
  '0xc458A406b4b41f8550254Cc7Fd950E3E27A0Db3F',
  '0x84d345DA4e0f79bA717fFcABfD95Bb285D643E8B',
  '0x22F3185db0a560F9106D7C84d4A2Ee0255A0aafD',
  '0xc55Dd8a32682E5b098B2d36B7465b882096C07fe',
  '0xE408cFf0bf285a57c347e16C7E41DC652CaDAd90',
  '0x5C01b81Daeee9403F4a723bD4E7f5A60898A20Ff',
  '0x00000034052862A6F264cFA365191822aBE146Fd',
  '0x74FDe5DF1bFd685e65F2266fF280cD4025C04aBD',
  '0xC8f5afD69C08b56d5E9acf40447A256281994460',
  '0x982160400795773de8867C1CC6AA1fe34e8c80f6',
  '0xE53Ad92fb11599447935c0275E688FfA13D8FCB0',
  '0xFbc5329334A835678B48045500ef488c88D64E05',
  '0x35a48E1Faca7738b8cC07065F6b99391955C9CAB',
  '0x88C032fA6F0c6eAB46375bDD92f1CE2c6bfB3702',
  '0xc6B1e716E8300C2f0124dfaB18Da02fA0774C70d',
  '0x70cAFc47a8e4eD567A7eFB393762fa949495205a',
  '0xD845d74948e8F7187CD72753Df29EcC8d1045799',
  '0x2A4C37534E7950D3D459577420770F8439CedEE1',
  '0x772e65aDb8e3E68e1760fADD2d95B66447278e1E',
  '0x61aE6Ce1F83b79CA28dbfA732f41811d63E95966',
  '0x2Af4b96fB69DC868eCd385865501460611AEaC4C',
  '0x3576372Ac7631AE5eB395BAb04004aa9eD5eED47',
  '0xA893dc5C6E20F0762138614cf45ecb2D4C673f9f',
  '0x53f792e5442E7454BFc2c01Ac8A62976B4d35EbD',
  '0xe74A3c24CFff39ED6A98c0A1BA30B0913624afb1',
  '0x328a22F3f47295e6Caf31905459F9d8874c4Bc85',
  '0x153185a1C74866ba4B36D7Dbb248EeaC1b7DeaA5',
  '0x162DdEfb99E76ccb65d8607Ae40360be2C8e98A5',
  '0x4024c5268359f091F57B735889fCbB4d930944Dc',
  '0x1ad6146914aDdEC9Ac2A49fAe6714Fdcca72EE9a',
  '0x472ad01f53deAC684c2eb7Ed18CF8a32a625616d',
  '0xEffEc5c1418680A5f7451827637Cc256A4C0aFe2',
  '0x4a7dCbE526798C7339Fc063aC3D9EC91bf91b1aA',
  '0xCaFEE84324Bd2bA6c33DD1EdDD7CCCC62a7E5076',
  '0xCD49502418fE47BDD7374E5fe6236a470f2F6Fbe',
  '0x798793f71D3f940613C2fea9f58f2D4dE54143D0',
  '0x78c44E0496E47A3C0B0eDf996E61e5735Bb40DBB',
  '0x445877b8b62Eebb5A14Eb6534f88e0cE3468af79',
  '0xbBD838624BAc17180365e6FC63d40581e0aaeCE7',
  '0xAE7d1b93F3a1C425056E4d9B7142e261E641f381',
  '0x8C70a0c9094442DD52460eeC351bc424C09b8ec4',
  '0x1ec63685Bea98862468f16418f1AE441ED0c094c',
  '0x72D866C3b9b1a40cc1e4E931D09f10deB1A5A0Dc',
  '0x614488B3ed9e250dd7644Da859D67074ec287Dc8',
  '0x9f6a1c405e305bab1FdBc2f6d10570E8A9f1aB9c',
  '0xFE0d823cC7137f911a76b9C8D432B4A092D91aDF',
  '0x45349Ada8CCb142F68fD10e289dde98fa585A325',
  '0x1e46D2897B9c769A4Ac030eCFDC2c95812728403',
  '0x204B7c2CB4114A22957f18e46Df0B17C68599D5f',
  '0xdA0e817E975C9Ff90bA69e6978e21315430cb81C',
  '0x5A54eA3a407a780299962890ec99fe542309bd7c',
  '0x63AF66A48ab02c102f175ef472BEDbc85b0e66f7',
  '0x32add9FB349AA7084a116E09C677beAc8fF46C8d',
  '0xb99048a68259D9C01F5800A17ce40B109299b0dE',
  '0x476581670126a013e4fe41B44174ce0284c0c702',
  '0xac7ca996876f69887a76932f6e48e3C217df7128',
  '0xB4DdE601f40DB20892129d4558FbfA7219f46E98',
  '0x43Bb861e7e838Af4189ddDf627a73e643BD30d7B',
  '0x34602825d2221D4F8CcE6fFf21B7Fb9FB341dCfc',
  '0x3eAf55786c3Aa629Fc0536FF912dd15C34925659',
  '0x24cF23516a167F2EA58D1186426a0ef97E8C5Fde',
  '0xCe9Da0445727072844b3c736c7788a35f605949D',
  '0xAbBF0B3901D293Bb2c603F9c1c46e6b590A68f87',
  '0x7CdBbbd91258900F4184eb1a829960D7F3FAF099',
  '0xf67d804a289028596fCa2F71F2b494DBA61c0A93',
  '0x807559850225076cc3e88dE6395fE66028F29acb',
  '0x4FE8eF44D914ffC8f02A37c487547fefDab6eaD5',
  '0x08707068F50E2C327Ad34084Fd92F4cE7F852519',
  '0x9ADCC295b1b24221E7dBB85cfb56017d43dFB85B',
  '0x8350C2D08a4776FA483eF53B9d042EeBD7d6a7bb',
  '0xAb03dB4A5De8e6aC1c921C6282C7691cBb9c6181',
  '0x9a6520D6f8ce38cE0C6e002a842ACE815bFE6A7A',
  '0x3A632cAC18Df5B11C823E257F7F0D22e133d4B64',
  '0x02bA57D9FB819E4B5e6A5b3bc82389aA123A0FF5',
  '0xc19632DB03E814dEe3Ae279d5b6ba11566b74d03',
  '0xA5b50daBEad94D9a6f180830D5D997361c029Eb9',
  '0x721f9033C0b6C66eE009b05B5bC33B170BF353Ab',
  '0x980712CDE97d7D991dc2ee1a2446d9A369d0F19e',
  '0x5dF1C9A1c5b63D7d8101Ab34932E7f1E4eCa06fc',
  '0x24512f96798e6932c0CD057f7245F4FE21742AA8',
  '0x305d4440156Ef53988c23f6C48Cfc635F76CDC4C',
  '0x23F821A90D8C65f05453F84ADE8e30779F5cADEa',
  '0x53E92846d9626886394ff18A3E44BE42229De238',
  '0x034F678ad3e808E6Ae2f1FDbAF1d00C6623d61ba',
  '0x0B16fFA9502E562c0988497BAd45fd9549C609C4',
  '0xF61a4Ff9f044c2C98Ca0E1bab1D825A24DCB3e66',
  '0x7362269Bf9B03ddc2Ee4DD03e64D78Af855Aa460',
  '0x6ed3877d927db2DE4f606Dbf4F7263cF26AfB851',
  '0x8aBaae83f784C233B4c9F05644DDd5d702741351',
  '0xef3E4d9AbA0b10bCDCE9E178850318DF89533482',
  '0x9F6ce0924cE40d0a7463490e3d9EF363a24FD8bF',
  '0xBd6239C56a7127CD583b10eD460c4E73BC91b866',
  '0xdbA5F5D4b3fE8C73e9F9CC43d46867b2cf191d54',
  '0x172ed82D3997A70f3854fA6340966B6f07a83cF7',
  '0xA09F46e3B7165bf38AF1AC13D89be34bdf662E7f',
  '0x47729839A918E9B694749CdFdcB68A53A860a8bD',
  '0x7b284248C00b9ebe72F82a6D3a3B11915d5BaC59',
  '0x2c9D1831cb67AAa1e786B4bB581A145867C7085f',
  '0x3e7507BFa308BB1484de7483e5035A4D27dF190E',
  '0x6F030B74371167d3B71CF3214E749B0d1814C049',
  '0x465f940D2EFde0aD18B30b69acecC59dc3AB7f07',
  '0xbf37F67C3620ff73Ce8362C8aD4d8813AB0321F7',
  '0xfFdbC00c9645fA08238Ce687FEc968219776382c',
  '0x8afFeFA04Cb5F915318f0f2AAb369391B2879EB5',
  '0x84aeEf50078148BA3835F7a091df557145cA09bF',
  '0x734553464035A09D8a060575D8ba48CeEFE276b3',
  '0x7583533E2fA293ECef907639854643c5Dc473e13',
  '0xAc6F320DEf427c6F60f8f4caa91C2Eda223d00fB',
  '0x5c55E3b06e383EF69dC8AB1299f8536E11b7ddC4',
  '0xFAA911E61a52AC9f8db317c68257F46e8ADeaE76',
  '0xE4baA7420763d6B7854C30c47826f1317C2e8CFf',
  '0x2ac513C5628078BF5AE0571a00d0e4420262C5F1',
  '0x97887eb5d75e2aBA840247eC50E1D30DdDb5278A',
  '0x46866f1473645AAdb83C7528abf2291F9f8b0344',
  '0x03aEA2bF9e4Fe7f6C3fE1E31C0F33520E417F2d8',
  '0x094B38b63Ae9b585717c3dBa63bAa052b1662dc2',
  '0x4dB1901FEdB33b8c779f891c1113451a4227e64c',
  '0xDcCcff5042655343870306763f63c3f18BbB278d',
  '0x01B47C923E5FffCa9F60b3b82682d4088e6Da268',
  '0xDe98cF32e43B617AA9898d8D754740BE91B24f43',
  '0xBE61D2929aAC5aEe3E62adc9a59633eC16EA6577',
  '0x80fab22F103AbF7A0594B09B52Cdac5Cf71ACedE',
  '0x44cbd837f63581C2C85931a44eA1Aa16129d314F',
  '0x0441Ac0cA849E7B789E4390729E511e7a30415fA',
  '0xF2445B5688cdA8e18aFE4dB89d3C6Eee54b66A65',
  '0xDEd335861C27d6EF00C78dF36e8cD773e7B27A7a',
  '0x8499411Bff99ddE9A02903008F917EEa0E27B42A',
  '0xDB907984e35E4b430F58c7A6FddC7c5f20F7617B',
  '0x3322BE645Cb27246e57A274C98474337d091CFBc',
  '0x2686913a4D947022D08164Bd505Cf038Eba252fe',
  '0x000001a0707d94Be8F69aCa23D0D4628e878b578',
  '0xd1ab55a36d39a14a171d159d98b80c03115db331',
  '0xcC1ec0B04fa0C602c23D4DeBbf91E6844af48b39',
  '0x2AD47Cc1786b68dB484885568dAe3BA8fD69eD24',
  '0x03860973e5d2CFddC5cc038557acD005FCC18C74',
  '0x7639C8A695db31cA1FA511b75111A0CFc6C46af7',
  '0xb38D413533E25B2e3d20353c43c72721bB202b0D',
  '0x023fbE4DAe5eF0A4368C6376F6bA63752300C9C1',
  '0x309Ff6fe6138315083dF5871dE56a72FB41d9cED',
  '0x651d8c28Bac10B22bA1dC8a63054DE7076c64F35',
  '0x737C47eAd316C13f0095353C9720f5F5D0ae217E',
  '0x15e8b78b296a02839049f4b85279f38E5D7b6dAa',
  '0xD07207D545380bcC4DA985453BE45bDCaBe54b55',
  '0x7FDD7d131589031E672cc8468D41CcEe8C92dC0A',
  '0xfEAAdF8d61c4297EBA7D8cBDe44a5860Bf058850',
  '0xE043C4D72d90e2060c274291358812FE44a56cF9',
  '0x889eaa345efb4aeed8ae383d25f4fe8023dd2eab',
  '0xa6819285CE8A829c7fD67756B2140515A68B6B41',
  '0xd7ef1884FcBef7881D1450Ff0B12dCc4847bD742',
  '0xfdf70CB192c0eb3C9496fAce31Db8F489F4faDBc',
  '0x9FC8bac108bBCa48fAB8E549B01CA68E1Ff4fAAF',
  '0xC7083273cB598eA5C982f1Fa6c479d8f741fF9c4',
  '0x7BA115cda337cCFFd25f0774d8B1bf6838F40AAA',
  '0x0e54736D61c578cB254ef74D6598eCe99FaF8796',
  '0x0AeF9bECdE34B4ae5753be14287e61E69A842AdA',
  '0x4DbC2a2C03757d3959a84FFdCF50e472f55428E2',
  '0x8c03Ae47378f3052A15D019BBeeEfe8a96769F5c',
  '0x45d7D6941e8E4B6aC029eee8A74934A7147ef8bb',
  '0x0171Ef016235DE2a5ED3676a10B65480e84BE4cE',
  '0x21cf338ba416956ED44C120593eF94b47F8f0171',
  '0x8a5ed7041bcB06B0B2C07d07C98eAFc9CC12bf90',
  '0x8371ddeBeCD729Bfb14e4aB7D4aB2bAaDF79A4BF',
  '0xaf22c2aaC24F5a21A6A2FdfE947fb88e884485Ea',
  '0x17A32B4dC17aD96947DA951070816821E5d5aad5',
  '0xb5aa420fE926998D301ccFED8307e7541A055E38',
  '0x2fDfA251Bb81cA24875ee51605cd41137e0fbff5',
  '0x8999Fb3750e94fa05a69594BD3F7d1B7ae981C77',
  '0xfA200BB65dF90C1E9346b35c167884A864C41699',
  '0x7F36057fe10D56f8D22239520123d824b3D26161',
  '0x36177D78C05B00e04065DcCCBf2ba1A09a6A610C',
  '0x42E3a631d9E4338b409D9c9dE322E8BDF3eB4177',
  '0x35a214b13c9E223B8D511f343aC8Fa94293233a1',
  '0x463A8c4537a1DB1C30d3003EF5818118731EA3E7',
  '0x8D54A631212BcE56Cb55Dc6de861348e3B14Be44',
  '0x44A0bF4c3783c4ECbfFF94F85d8b49f880e5a862',
  '0x7aC8C815D676B0D12B58c92cd88a97D80D7A5c31',
  '0xEcd6676905518e9C3677f36Fcf6f20EC8d29F416',
  '0x25955cE732C175E701fcFdCB21B0F58a90fbCf83',
  '0xE0D3dC4Ad4d4974084BcC108Eb4292D6113EdC45',
  '0x0000000000B1381708aA7BD722dE1Fe483245ae3',
  '0x2b21e04509583eBbf2D7fFBE013F6cba6b6ba605',
  '0xC1A2E687fd8873FeFf50aC79d8029284D25a60E2',
  '0x0d88EB90b57F003E641B8109533EefF717fC189E',
  '0x192532AE6dA791Ab50C61ebcb5431008B1bE0719',
  '0x27B8F139316b4Ba4DD2A39417e41185Dab625a02',
  '0xB4b38fbB72bcB2686202a9746C19521c24f0F35d',
  '0xA2cbfCb806b634201c3A62b1ab10dA55A9467Dcc',
  '0x503F9Bf82303f026e02Ad19B1d709d34F1Df0BF9',
  '0x3c251EB5b36d9FB9C9Ab90eE39F35513552D1F7F',
  '0x39a3E4E39b9e3E792fa01A70cBC151B76f136AEc',
  '0x8F57948779195cc2EacaA0633efE093085131ee9',
  '0xebCfbFcAB19b455DA0D7641c259df805DAc4A4eB',
  '0x8d82e49EF6189d0C5D42d6b155Fce4834D809318',
  '0x3bf9bcE00785904572A83Bc1c63012f99a92f648',
  '0xe36B88a507571f29D0Bb5A13CFE6A80DaD4098C3',
  '0x6591C24a7f7d3B37527487a457b2f467936DFE59',
  '0x7d14f99FDdd9Bb2938B6Fa9BcE79B836C23169f6',
  '0xbCd214Df1d5a65B45e32adf30C214ef1875a7b57',
  '0x99Ea56b627e2eda6F40C1D3459ED552558351c1A',
  '0x543c00aD88C82255A943998F8104ea0eed47aa9d',
  '0x548Be6667E92E742Dbd852662349ae74Bb39A215',
  '0x7ebeD995aAe1A010c45AbE612bdAFdb76E0f95B9',
  '0x16Fc26A2b7Ef6390D2591eAfc7C61FD842b98c22',
  '0x2016deDc02912bE50DbeD8e8093D1e3fF528bf54',
  '0x2d2734E25850D16A30cCd7C60C58e23a242c06d6',
  '0x08B1ba9cD8a4b7222B220489574aa1dDeff752F6',
  '0x5D97261EC8e26F2631df1ac8EB6212A090Aec092',
  '0x171218b8e50a3577e12DC0D1b7032FF23155d03D',
  '0x01521f06C55526a7fFf11236B9a4ea65986bc1b3',
  '0x3E83AeCaa0d05861264Bb0600179D8FACCe4C27b',
  '0x47AFBe262dd9b6A3EE2254b004122a87763983e6',
  '0x526927b2Be31DA8dD411878a507C19A4039a1292',
  '0x12BeDff5350f138d9F2975018729301857CdF2E6',
  '0xe5c02961bd96181ed6de8415f9c6e766da6e62fe',
  '0xB327A450C7D51706228DC5026aA4061b1cD47780',
  '0xCE4Dfb3A4E053dcbb931f5ED5fB15F1E07955f9b',
  '0x8308e1Cac9fbd88aD21309Eb87798a4eDD59168f',
  '0x5555556280C9E15507D7475193Ff2dEeC88297C4',
  '0x5a64f5bc08458751fe843D95e8E5a3631AEb4128',
  '0x8E52c66765DE5e61ef6BC36B8f62e79566DC7251',
  '0xAc99f851e12F799D4649406D20A6c4f48877A2D1',
  '0x80572C8FCdE67C6050099deD81a6f5Ed87b2B77F',
  '0x5dEdcd5ef79127745EB02ba25791A97f3A43a557',
  '0xeDc7e1571bFca2a9501E395159545C676A0EB0bE',
  '0xA0551D5a71c269975Fee878d76FB2Bd8a243E37A',
  '0x713A102886F77a2F8661C406cd7348cB80Ac178E',
  '0xE6EdC5195E3D97cf51ba026b7Bf29EB910844516',
  '0x4531e5dA1AD398291312712dB2AF3de4cf961f51',
  '0xc1814D7708880194E83202474F4F0b9D21AfBf0c',
  '0x07064128Ef444f07cDa9707764CFCf93eB2c1857',
  '0x028Ba77d6E50d8ae3A7F2a52a9791442f17297C9',
  '0xeB41Acb7ccA431cf7622Fe242478E2caB38E061B',
  '0xFCe8BB866c46EF053c14eC6CAe2c8922cec217Ed',
  '0x8a6ab47B1B794275c9e4D931e1F096DE117D775C',
  '0x384A9d93752Ab9DF9794E3EF9Cb1c8710DCb8a25',
  '0x1BD7ceF6c6c161ddd96FE4e0B106502794eF8e96',
  '0xb8343fac457B2bA68981839693E60249C79c70f8',
  '0x0EFe3d6Bc060657f8C8250C8D08C0c7094FfC41f',
  '0x6033f8fb77cdb92541139207715c3Ce6D476FE83',
  '0xcb60DB8db7b3602D2Eb950ecb445104cC9668739',
  '0xE530a688dC686F6D45E13dE765fFb34487D10095',
  '0x201373f8C6e552e9957aEA252624493CE92AF126',
  '0x4a7f1Df9b2C3801198AC7c28c93a4273b821D2d0',
  '0x6E246BCd173eF53C44dD0109be3ff928E7C92F0e',
  '0xCF432B0DA6B77f0357e44d5dd5f041A2715ce330',
  '0x49033cb23d0e7B85ec2353c4e0E1729454540bB8',
  '0xcb8523CE4f16B93b4D963A1E8571aA4Fc13e94D4',
  '0x8464170c9Aff39719545681477f22B0136ed33C7',
  '0xA26b568C9F6adF8eB536a390DD233d8425a95454',
  '0x289837587f8D061a5A6A2917A5e69aaA507aCb85',
  '0x2d16CF0931063b4544d514954114Fb874f3506dB',
  '0x51715c54c08cF3223bf0DD1b58BFD233e0a81d9d',
  '0x7eD470e11d8fA1127FCcC3E8fc0585A953767994',
  '0x4d46A98BA81b746E687D143D03D0bbD04905882A',
  '0xCd51bE3eB3e13d1C144a7Fa2536C12A4040A8E29',
  '0xB1CEAEfeBcCF39e96e3a158dc40DD78d9bA16003',
  '0x41F3Cf9e7fd4e7bA9852A849EAFDd049C9104601',
  '0x768a7D982f30095Ab9F3822d21f07ed4852E37Bf',
  '0xe3D4071f5956bBbfe7a16822472d78ec3B991EE2',
  '0x8e78367D092056b502fcF989001FEb03b53ADD85',
  '0xEA0fA902458ACD4277Ce915D36818028221E8D0d',
  '0x4f6d3055f4FA68446ec50b9953cFAE19f8dc3959',
  '0xb135Ebb522CBaC4f1fd52eF6C2581E20cbF7A575',
  '0xC00cACd5C51cBb1901D8ED6aa9f9C02E36939467',
  '0xdF40cd0498D8059E5c7eBC05cE846dc74Bec7b64',
  '0x4DBef3BfcA8d83E57c09371A77a8aDd25678A5bb',
  '0x02E5Caf528b5631f90651168c0a293B5b55DA363',
  '0x45c36DfD8E89FbaCB948D12DedaaDdE78f94aae7',
  '0x988AD13E5Cac3B66164864Cd01b0cc6Ac021bdaE',
  '0xE6D153Dae2F56c68f52F2329dA227c1d4C58ba7f',
  '0x687e21CF240c2C2B91F160620f69673a92938358',
  '0xB130a894187664b22b823DE7bB886E5C09e27d51',
  '0x0e80A44EA5A10C63b78107FFcC4A8bA6eDDf93eA',
  '0xF2162Eb80961714A81e3B6Dd3Dd7D4DfD85a1121',
  '0x83A8bf5f7B9bc69aBA90A589b553Cb6Df0259e81',
  '0xcb15463AD4FAf57e7760D3430eF8991Bfb2e20a7',
  '0x16b2512cb87323A388D48B5a75a9F8Ee325f2861',
  '0x4b1924114F99113336190DA281F12c01453F0165',
  '0xB66E3bf8DF6ac2380C15d2cd4F34Eb94BF1b5aB4',
  '0x00000624Df167f053a553aC426ef2BB85b19a52b',
  '0x7b84d464F76fFeA1CA11cD57197ea5Acd981c9E7',
  '0x1Ed827c18036Bf56BD0509B38e4a3f1aEf9ef939',
  '0x6477c539cdDE59499577d05c342356eFe1aBd38c',
  '0xdB45411265782deBF29A7b58Ab475BF75C9b19f3',
  '0x8a9355dF355688d8B9C2703E0B10C78A8657dC78',
  '0x915D72Fd6Cf53c34D6b7C238be60a79d5214C452',
  '0x68F91384E08C800bBf81d650deaB48cD90f4e696',
  '0x381837b7B0EB014Dc0aBECD9724e7Cd866689d5B',
  '0xf14A2b515FF826089e6899d226e526af373819b3',
  '0x517b5082f6e13d9aecc1791ccb0cb58b2484a8a0',
  '0x137B9E4361C8ff02e6E1552B635f0824C9D9Ce34',
  '0xCA590deEADc1084fA715853Fc7D282f60543631A',
  '0xdfDD2F210b13A5f2b366147099e77ad0B5bCaDE7',
  '0x65BD348C1C6e64B5f8E9E14E077514cB0286B460',
  '0x6498F6CC59F64d01B841B2619F7692cfcdfdaa81',
  '0x11AA0d38904d7b070f466CaF3B55B2226Eab8F78',
  '0x20365D5e968f570Ba800123531Be7FC08404862A',
  '0x4a0dc3fB0c2A232251342147C4cce8D859CFa521',
  '0x463cF1755E31f84164355dD849ed12f7d576F2Ce',
  '0x987315E6546492A8C284b17d9bdaE6ee1C5a184A',
  '0x1fc8aeD6869C7F48c64b8f01dcf6A35C8F1C9086',
  '0x45551927f49A53Cc380412fc7B39C7548E4ddcCF',
  '0x21c70Bc7E693B1381595f5a5AC5451453992E27a',
  '0x125a2f579372c91c819a240b546bd293DB4278DE',
  '0x23c49d92346eA1E23fe78145CAB8CB83Fe06ac67',
  '0x592fFDb1a4B08163C464C311938EAF9BD6A6A19A',
  '0x389834befff6269aF60077A0005FcD064690779A',
  '0x36f9b93D7b556A311b1Edf8b909Dfcb10Ce4c821',
  '0x491771c9ac70A1b5b4cF7E114Aa10FdF8043813A',
  '0x5a3eD638De9922C8b1672a783caf60e2C83519FD',
  '0x13C73848D9906D77BBD17CC79D21C97D3619498e',
  '0xD6D40c0f5BeCB8B658e8504bFD17272FE561198A',
  '0xDBd4B7bB745acf5d47Cc3f01987617c1dd1B1fe0',
  '0x2C2cD7a6E8788Af2042D741d6A6Dcd973e3649Bd',
  '0xd56df73793D1F7229deB1171b829201f53BAf306',
  '0x52Ba9552634B82f780E806829b17f7E884b5688c',
  '0x350061d5B3B09fd44691F22Fd9DEd9a5693Ed41F',
  '0x8C78F5C65256f23b65a7c843684Ac5cECf5D1BAb',
  '0xDECCCee2314B572926B6a62A2f1d1FBa7B2c23D2',
  '0xED543e2D5b15DA353235011278f8Eb50482984dC',
  '0x5C16891CE5C28eb2FC2DB61F187bC5A5AE17DB69',
  '0x683A68673CC0688d551960f411AEc6c666487B9F',
  '0x55D8ceF2C73C834B29Bb67DB10fAa58fE695f6E3',
  '0x3bE6E7d19570Cde2aFd7F60115A8eeCae81E8C85',
  '0xE10F731b4bccF66B286e0B1674ee6260841af449',
  '0x998Ae65993e7062ff9Cf88E86B23dD148643F19a',
  '0x69BF8bb7CD89bB1f7e810aDb75Dfafe71b1B3bD0',
  '0x0fAf0D5fDF245cf567E32C41496f89e4b9ed1F27',
  '0xD7FB3b288Db9448c14dd373b765F29AdD2e5b176',
  '0x64a9Fe7Cba281bc067877Db3020992abeaaDdF89',
  '0x357b2E6b1ED3F579a57dd6368f25DFBcD0527d62',
  '0xB06412Ad37f4cd68787bE129D00fE5858B2a8563',
  '0x93d2C526F0eB3732FB54ed5B2452dC864a51b451',
  '0xB480cD4291DbA1da4F64111cF25a4D3E20d8F697',
  '0xC8a7Fb50567e01376baa95CC94482F8fcAf6d301',
  '0x79FD75de8de5438dD61b798F4f69b2b0C8ec287a',
  '0x78587C008b6e3E2Fd79Cec44845BEf1d97151309',
  '0x0ee7868A3a4DB395E40c8e173d693C5C8C1d580C',
  '0xE2DF865eA6ce5F251b257e44fAd66E9D97244A93',
  '0xe5073Dd5faC6Fdb1C50167dB123f0C56bED3d476',
  '0x61c7adbff163fe957a944909e3f9e7cddbdd46f0',
  '0xa2a4f6e945a4a15ff04e9f156eb6d55f1badcb2e',
  '0x040e48a1ae4ad254ad3a3af9bc62f004722ae575',
  '0xd33d19b68bcb35093563c5d67e234ecfa25dd6f5',
  '0x68DBfb911bd63934df57aD615804711ec2bBDafe',
  '0x2457C41946205b398030Ca16bF0B71D4BaEe56db',
  '0x65Ed53A1150386c376A02BA6514Edf12354cB671',
  '0x8089390Ea727889B4133a4fe175B5F00FD9cCFf3',
  '0x51669d122ba4a91e73796c26798C841B0ff2a665',
  '0xAa968ed7507B2447273848CAc5D5e83Bf2fb6bdb',
  '0xE5C33D47dC6e63385a35F25051D9Ef3AE7c47083',
  '0xf601cB160afab3C7CC2b912Dc8Aa831606d7F01b',
  '0x36aCB7a9f0C6C44c6aAc69196aAd3735C4CE6f47',
  '0xECC2d9CAb4c95198Abb2C9e0cf201c8F90CBA615',
  '0xdDe4d96C49eAFfe834b89bC1348E4c4b4dbf842e',
  '0x07914c327aa02a2b11454474a947f97a0302493f',
  '0x351e045bE70BE6F9b590Ac56371d20DB8974394E',
  '0xccd75713e43FF742D6aAac44bF1Abb6e72D1aAE2',
  '0x898f889239D756125B9CD4967924214a366d69aD',
  '0x3A41CCf7358C4e3e06c085554521fd6540C3f216',
  '0x36f79e176e43502ff67da1e8a514d9736f847fbe',
  '0x5Fd2A5f56296Df455FC5C6D760211077b2010Bda',
  '0x31f8975096b2a22965590b6177d27f18fe392489',
  '0x509C90ce395544632B0A2f8cC94815F68B7C831a',
  '0xCF5a006Af50B072022138B55dC54D85b4980E73C',
  '0x64454c58415857BC14A4028c48FcE3FbAe7DA717',
  '0x740811229C6d03412d10BA4c1E3e1De82Adf6385',
  '0x323d332b25b81560450714A81961fa1B98a10044',
  '0x580De9d26F3A9C0B2EbA4815388B217cAb338C77',
  '0x97B64158034e2bfeBFBb765E57dBb9e6BC30f6fe',
  '0xB42606D61355697701fD06e4a36eACc5Bac21a93',
  '0x5422B45D0D939089fA627b5B13DFc06611A47973',
  '0x036729deaF2fDD1854309C789aB8Ff6D9dA64792',
  '0xF99dC1a2b50a3355112AB23214E5726Fa4f38161',
  '0xA707ad9B3a21442A221da8f1E11946074fabFD9E',
  '0xc91906a3c163833403ADD0730f80B0f26C98F028',
  '0x64b157C865739201aEa2079F6C46344A4303cAcc',
  '0x5af964b721d000A9CC4F6c74FE841ed0029F3119',
  '0x1d6B705ecf12B7b2EC2Af7D943e74a16448E3c19',
  '0x92594103E29985Ec013603CE467167ECdC0599C9',
  '0x7Fa6eD463c00A8e3772B8279feAD0de287cb972c',
  '0x7c3C16AF8DDF96582223B2e48f1F25EaDda6b9BB',
  '0xA2DB1224eb589665fEb70E2cF1D4fD444D8a1DeB',
  '0xB5B4DDa82C4A3A176fa520C2618E5b889b7B6609',
  '0x348a03cd8f9Eab2c55F9eca9cE48caC41EDe5dcb',
  '0x480fDAC187f65a80D2559f2BDf7f5db9B8E36D2a',
  '0x1009D8Bd2fD7F5992d8182f49872039154a393d3',
  '0xC3A391e81B4f5A4C90556bf59689fA7C6BA4A642',
  '0x429A4266CaCb7b226b86f309b5EA8Bfe705d3fe5',
  '0x3c54B0b7C89d855e860f7B6d42e8db6e1433049F',
  '0x8130d385e77517bf691Bb14679dF7da23bD71e80',
  '0xD9e312d5c2C95491DC059488De01C0d2560Ad4b9',
  '0xcC952c146705618c18502B37A1fcf01093FFb282',
  '0x31e3214F76FEF3C895360aac9779972Cb7E60840',
  '0xA73F7c97f6E97b3Da2d59D42902B9de8c4F55d83',
  '0xC8bfe2591052Ea577f7dDae3EDAFFA036b7C53c5',
  '0xa4B86898F6b7D0c09E52d60D76868bF6C4514cEC',
  '0x834b63703D0BE659316D58cf8B46f69Ba8Ad6830',
  '0x14c0442AE3a87cd5827f96839694b458ba87ec63',
  '0x7b6AC3bf62Eac791181Ea669Db3082836463a570',
  '0x4C99F45E75f5e5B50e19516c4dE9D4919b8309d9',
  '0x9Fb0cF8f8Bbb925C899A0b4b09Bb2f652E6C8063',
  '0xd97dF01183e130c17EC519794c6858764B4527cF',
  '0xb090a7014570d4C3667E5Abd263dCCCd3B201726',
  '0x5cAb7880a5AcBACffb97152BFe04b970cd382226',
  '0x74615964712F06010db80ee1cf03b4209AF2E568',
  '0x056Ac9EA2962f5cD274b073cD2be7343B426C5dc',
  '0xE6e6A24c9864d6b0e341C073B93729281C49bE3D',
  '0x5c55E3b06e383EF69dC8AB1299f8536E11b7ddC4',
  '0x3e8983c02Dffe1614B6d7b9be121B8305eFE8a2D',
  '0xb5dc04cFf504fd506A3A21B0BAf4DF5de0211D2f',
  '0xBA368C04cE151d4BE478FBAaa18053610bD38536',
  '0x488A1D6246f935315A933038de91dFad6CecBF56',
  '0x7E2d570C97792C8ffaBD8f9A54Fd7855C02FDA6a',
  '0xb13F016536DF6D60a4Ce41851644CcA55c9A6521',
  '0x816689ECa40ee50edda16ffd85257c38976ebc40',
  '0x93CebB4004D18C987a0F22CcA7877A41304Df519',
  '0xAA2220ca823a3bD95f910A80919dCE90e42B7246',
  '0xf579Fe6D6f310F02A1BC289Dac7857a421d1fBfC',
  '0xfE2731F093D589dac94924B046e0983fc39EF61d',
  '0xed5cD478963B9FeD2418936CE4e1904b66e9BEfD',
  '0xBf53A0FC0759bfCe1bF5560bdBa9cD8e7c109EfA',
  '0x8eb0Fc518Ef46F19A559Af44B68698958f4aD62F',
  '0x331315A3ECe1ee9B4aa95151c0f3aFcD6c91b0de',
  '0x4E4ce57Fe0AD4b2d2B95633b00226F857b9d4b53',
  '0x05907bdAAc108DE5Ee908a07157496FB9c0134e2',
  '0xe01dcD685Ed71cFbB97744CBe792280FA811da33',
  '0x6A3B77729808668e6E4a18Ea835E8B7c17Ad4761',
  '0x0DEd3c8Ade410d8d604F2Cf6aC533105dff73d67',
  '0xFbCc44742A3DF16a139FBCB3ed09A5AF91Bc36c9',
  '0x931c78A4CB43A4bD417E2c7aa9f53459eF664478',
  '0x5c3cAEBe04B2d4770698419cebC88cDaa9e88bCA',
  '0xA32910D56C54C110CEc0619e94C5c1a875321FB8',
  '0x661de7daD919e7313C03A39BcD74A17d10eDB125',
  '0xB8d61B1fE18209fe522d6c0DAF0900BfD7F20f15',
  '0xAD87434f38F4C9EA6Ee01A84553438694C07b0dD',
  '0x7A34E75dc07d917CfeFA65D9BCfCAf2B25C52380',
  '0x055fE0e47f7DB8D3060e3cADb0695b5069c4Cb1D',
  '0xe4FA6e4F3a28807292227A06069B6d30B214B83a',
  '0x22c20bC8a791d22426Aa0fDa45B18F11413667cF',
  '0xB3aaa2150140F86943af72636440233ccE76A971',
  '0xf48D752A9C61945B4cef99F183C722aC040Bffe7',
  '0x341e1A4d357e61fbCFFb988e9026aD439d9FBbEf',
  '0xE3a9F83b6722c72820ECDe60dFEC49832621C58D',
  '0x432454770b94e1F490eC2fDa23b14eb543bda8A9',
  '0x61E5ab355B98ED4055282C1AC5d5cF738BCdd630',
  '0x13fD08AE81263c8eA527D3F80D6723985519234b',
  '0x9662A3d7bd4E07B92Ba54F564D9523E87A872291',
  '0xbE2c5791FFC9E0eCFeEd507C525867Bfc76Fe909',
  '0xfB1f85f8ee7725fe450643726B175cC01E457370',
  '0x32A76714aF25a7DAcADB91Baa793d1924D6F1488',
  '0xF4849B41335B0BA6A111e4b35fBd5449008f35C4',
  '0x3690161C81D7A330cC66a4Af7c011dd416c36b14',
  '0x0e22BA9013D01A15655Ea4417604A939Bc339540',
  '0x968ec4D8080162F5C949FB2845034d9A81bb1022',
  '0x687Ee762f5AA5dAC1f0ec76624B16B5fC4c7D97F',
  '0x443cc1CeF791BC08791a06dE35fC551c13cAD50d',
  '0x2d70ec71de4ff7406e7f8EFE31F33b6e52f8d30E',
  '0x0c771F34F4Ee3f5EC0A50068ba49f145FDCD68Fc',
  '0xe850b5c39f831BE2C3181B720962a28055465b66',
  '0xdE7bD032E4031D7D1091eb099C5743d7ac9E222D',
  '0xEB5f5879087df6AcBFE7415b8C03d529211d1AAD',
  '0x09094a3C110779A07Ac42969072bc920909bC0cA',
  '0xfA18191cA5bf0A4585c5631f1683D5Ea38DB26c1',
  '0xfD9998FD5BD06C7a882d29960DFe83b46CaE7Fe3',
  '0x9E417397badE19F2E9071dFAae6eFa2F456A7ae7',
  '0xDfCA3dd6868ff3E15F0e444b072f34E5197FFC9B',
  '0x401c0fe56AD89Da09E1c0e2BE5d8f83F2685e780',
  '0xe4FA6e4F3a28807292227A06069B6d30B214B83a',
  '0xb1a37EF2e5ED0ade5679403E258FB02f5fDAd987',
  '0xa869c60C66597FF7BFc020052223eb8cD9Ea014c',
  '0x4CACB9a2065bE7bbFF87Ce9e8ee65A8CEC0D3593',
  '0x7B074b612A645bE6C4890713D438959C8569af2B',
  '0xABf9bFf4c4Ddc9954Cd13159b3b3115634782677',
  '0x2720F57263d992Cb4574770af0ab110ECf8D2abf',
  '0x240d9d7A63f4Cd5194802d1d530912011CACF386',
  '0xF0966A8c96cd1e5D64959660F87a8F3e866438FA',
  '0xf9b9637D9C3119B117fdDcAec6eBfbdbC72AfcEa',
  '0x1936243ceA155edFd1f26DB5891EE822B996B7b6',
  '0x22cd7A7e92140555D739890D90620880eD326bb6',
  '0xD3cDb73f8Ae4A777c136020ee4318c6EBCE24d6b',
  '0xA464A0666Af83ebD21d94bD7D1E80cD9d0402956',
  '0xa0F3d130d404d4e892FCe6847960478DFBd8513f',
  '0x6554e83eB60f76F018989462898F3F36c6969463',
  '0xdD6D32875b7cE1b3DA2d273DccFdB30D4055fefa',
  '0xB1A6C42611228c40Fd165cce39420862c6c08d35',
  '0xfb5245c586b0f18fd05add89f59dc50308ad5f5b',
  '0xf7401c0e16D547FaAee4e156Dc1a272d8CEf5c15',
  '0xC9F9060d69f6D9C82976FFB26C5BFC9994581c7f',
  '0x410a9B4B0505C8F1F470D9348e7e21e95e84B790',
  '0xb9c073281C8771d88105eC6f232CD745d2D32aCe',
  '0x3408973D65805d505718cB2733206caa7f96BDD7',
  '0x0b217c45fb88d63DF787AF0cd847BFe8A35b01EA',
  '0xcBE36D6b89c5e07e14347302eAA01e6A82345A53',
  '0x9D9c5E6a901D7E38fBE9057f1B08970b7e0E63CB',
  '0x96F937286A008BD3D140F41dbaeDF4ad543B9A9c',
  '0x53777ED6B8067f2E029d0206eE1A02cB7E34bEff',
  '0x21fa1ABf0B7E701E97dB5fdb0c7f131AC9a21d7e',
  '0x6f2a7b9a87861F00911A0A3a8106DF83fB6cB542',
  '0xf88801F6053e23212b3ef6b4e0B79A9Eb11ea6cf',
  '0x15047B13D05F2b2F5871025e563CFA1304f27095',
  '0x51eA8943887D2abe729A7CA95128Ef68AdF1E950',
  '0xa3623B54A0cC492050fcF495728c5b99398c2419',
  '0x47bbf903C9A3efcf277F6e4ea2354361ebb9C528',
  '0xf94721b655D4F83E8D75ac866e970abc6745E419',
  '0x8eb59f827365940E6815aCaa51D92EB6a159deB1',
  '0x77C0d6cc4ddDbd1518FE6bCDeCC756F6B71B3fc2',
  '0xAcac62f2a37de88324d1d0Fc2b088E190221A61c',
  '0xdd84a1a2280e2b74FEF1cEaeAd647EA8B63FF2Bb',
  '0xF21AeDe7B2459e931f302eADC073F6b839eE17cC',
  '0xf476Ac20Aa65b320C47C2427417910E3D802E430',
  '0x18e944accC1cd5eF0bb962c41cABa8e0DBfA653B',
  '0x0bAA359415BA79F7989EbF419B7B148e2E862F11',
  '0x021253EcC0141d1B84a7b0f61fA879EB1e1A24D1',
  '0xF5C8034885b10Ab81a08Cf85a0dBB9a430028712',
  '0x3bDe2fec2e4b1F911Bb07A08f64F67b83D198F6A',
  '0xb5FC3d9dC60AB08EE4cA58804b15DdD7fD95dCbd',
  '0x227747eb61cF5A52f41De13F517DAb233E476013',
  '0x5977ED2b6D0BcD125B2F563b0d5B3777130d0aDE',
  '0x3C7B11f84F89b2Ef686478f71373BBB51dD55b7F',
  '0x7B47D826aFa02f41c48c3aC1B98224C1Ec91e0f8',
  '0x5590d18A3F70fc1cb57D7175C4bEbFF32825BeFE',
  '0x52eA2469DeD50C080574A637Ab6dAFe4214eb46b',
  '0x3811D1B73EEfD6CC5CE73A052BcfEf5671C1E602',
  '0x823a3439cc2EEa28FfbCeEF117943E35C883510e',
  '0x00352e142A120ACE033752af13EceBED787ee288',
  '0x8CDE3Eb3EC0d56BD8989C83129b224f931acddA8',
  '0xE118432893D56e79bA5f68F32B35146a92d03213',
  '0xa2D2ed6F0C672BE216C03982f4eA61D5e0e4d1df',
  '0x1e45f5B1855fE529B46b8886F69aae22b38687Fe',
  '0x9bD3e77A10aC987d44D0eD94E421D04d3DFD770B',
  '0x1C6aD3A22a8f40A00a106Ad81B885519BbF43CED',
  '0x795301d3dC88c94896d89CA8f0F6CF3a4fb5EeED',
  '0x1122a0A6c0Bff5fDACA76fa9F66f7e00829F8F1B',
  '0xEcd13bAea848535e1aE960d1343b07F102809Be5',
  '0x43f08aaAc525B75263982b1171EF32495eFA2ec0',
  '0x0e54736D61c578cB254ef74D6598eCe99FaF8796',
  '0x933712Dc96f1756EEC845b62519Db466EeC35D3C',
  '0xaa58Df13Bc47A30B8DcB9f9Ebfdb4B0fDBF12f50',
  '0x4E4ce57Fe0AD4b2d2B95633b00226F857b9d4b53',
  '0x5A713919f012fc28Fa1D447F5b5dA611E6b5bC90',
  '0xFd41C43280F43AA6DEffb30A6DDd7eA96DffB15c',
  '0x42FeeC5c7e7D3c725864A2716CA357Fa9993CCC0',
  '0x77fdB9F278AD273c130DFDb8F59ab8CDda34D134',
  '0x80654808F16B60A5491A31ad11f73A7a212ae948',
  '0xA1e252C2e45809DBA8163cf8dbFC9D971b2ed7b9',
  '0xC07661ED8EF90c33b1223D5b20344B73CeB14161',
  '0xCcF1058713369395D6Bb15bC0Bc7E63AEFF5a46e',
  '0xE21b7E0A4daBb6e11a86266af7EAdcc81196a113',
  '0xaB5DEee7c20A143d28a5EF2Beb0aD99a4F77eBEE',
  '0x739720CE6613952BB941Fc89a2E6f5CBbDD66Aa5',
  '0x80eecb6278DCC2bb3840a59f1b3fA314C972b8E9',
  '0xE403Ab4aD30514f73F1f4Dd85499cD93ED1587a2',
  '0x4a7f1Df9b2C3801198AC7c28c93a4273b821D2d0',
  '0x993826a6F2e3d33e3b87E8FA7B5668a7d82368e5',
  '0x06e0942EBA7E6D3dc251CCF4c3987c7b3e1a7b00',
  '0xC81f7cdA9fb9297aD2631517a57b9486d384623C',
  '0xF9AB0ab78089A1bBFbaD190539fcCBE1DF807777',
  '0x1d5603071B3a2C68C6Fed879eFAE6F9Ae4db84a4',
  '0x9F1DAFE36786701B22cAEFC3DAB70dd8Ab8082d8',
  '0xf1331a0984c35cf9f9f459E7291121d5CED15bD7',
  '0xAa3310C12e59168809450EEb21Ca864779f46F18',
  '0x7C74125148D2997451F79fEd07c3Bb603621AfB4',
  '0xC84FD1109f769e1C05852Df678Da5ED015109993',
  '0xAC1281Db6B2D853F01FD1fe85cD6d6dC4096Ca7B',
  '0x0F4f8410651AFC8Fa3e89aC9b6135DA3AF4D778D',
  '0x74230C10229E924a2B08734623Fae876975D7e64',
  

  '0xD332B862Cfd45489A5A7f51D1D4d906Ff71E96c1',
  '0xA2D35E418814A8b6367c66a5ac2FEc8ea16332b2',
  '0x03EbAc2D81A569a024c7D72b27aa25297184ac96',
  '0x37e406f6f13c69f2ef35b8E8a5f2F06eEE7D6fA7',
  '0x3bca8c8a9b89f25b014ee5f35698ccb1aacb089d',
  '0x1fbdD20eb0D55DB3C1A09CF4cA4853fd36Df8726',
  '0x845d34285842475B92C03d0f2f24b984B6C6309E',
  '0x6742ab4A4CfbF64035179DafAa6e04fBa12EB64a',
  '0xfb58889acd8Cb14a9a9c7Da47270df55e5cE92Fd',
  '0xde1Ce624097C812096Fb07cd0427A24E807D5775',
  '0x05C4C197e01144Ec0751343310B5D0c945f34127',
  '0x6BD749821b7D7E5Bd06D7511A3279e200339FE74',
  '0x2A92dc34517A17B62eBc32760E8F9c475d93f241',
  '0x6810e569633b4732ce1306F9B73262477f83cb38',
  '0x8118bcC3543dc13B14981182eC933F0195e53767',
  '0x02F74aCD09B7c6606cC4DbF62ebeb400C7435423',
  '0x75037382006000B02A835419D0F4Ecd77E0b0040',
  '0x86CaCBFAb0322a09C46569BB187ae9feC24e55a6',
  '0x0e668deDEFe455C6f00192088C1B67Effd1B78a7',
  '0xcEAACb1a4b3b293D13E8Bb386092Fde89669AC1B',
  '0x793216EC59d68E928a8C32bD17992909D67510e5',
  '0xA5b509313d1391a796dcBb440d099e8FdB96535C',
  '0x9A608d9F416518b5F11acf3dC5594C90D6998e2c',
  '0x6F106e0ef498a594CCE8280976822fA3798A35cb',
  '0x165639Af5B93bADFdEe8e6A24C1e03C55bc4f428',
  '0x44763e057516c64054d7A7a0308C52022Acb355C',

  '0x04924b81c9c3c5722070bb5dbd023a567728167e',
  '0x81EefBc14A34408913497B084b68F6321ed04f47',
  '0x9Cc0cE0134506004C63DaD10ED53415EFa596990',

  '0xCf3A6F6C256cb01A918337895750594160928733',
  '0xD3d5e1dba977A6CFEEe69845D77e401A9c1677DA',
  '0xE3f078d698C940240e2618a69bCAf671d9cDB7f6',
  '0x19C9B0Eb1A2Fcd6Fd7a6136b4533b478f57C4D40',
  '0x857c3449c1a64f26588a21a6a64fe45d756cac54',
  '0x69610e1beb5509335177f8fff74ab9078994404c',
  '0xe5ED8C82eD6E7D1552292AD87A6f905c9670898f',
  '0xC30943A3614b35F7f977CAc2beaf0330E17872d6',


  '0x4a0C4d58F065aF34c31B1356d4933926173645E7',
  '0xC472EDc48b4B3aaF9F78c8d435bc2b78D698AFc0',
  '0xa40E867A4F295794487c8CCE882825eB65fE133d',
  '0x587228B66d6f877CF27ff89082aDFC1e8d4461ad',
  '0xbE14d4460f4aC2a2d17010e0544ae33eF581e2e4',
  '0xac100e87561d4f8db1c18706d96f8a59058D797e',
  '0xcb92E53e2C5898415B49815d560477F764875d51',
  '0x6867B29F8AF0674b660E210Db55752D53aBF05B7',
  '0x9cC5ccE0623bA9DDa9f30c7359995f2980CCD3cb',
  '0xf5bAE3E8f61468762ba115802570831F2B294C3a',
  '0xb4449f90FE785F1C764de2EB3BE86204EBD0C312',
  '0x088Ba7c136f64B692D1822F12409b2e4a4f239E9',
  '0x385d65A9D6399f3FA05F40CCFbDC9C1F084f4db4',
  '0x910fc410CA4AC5E4461885B5e479dabBEEE08B4f',
  '0xe0Dd800966AcEAD0Bc870EfAb9d2188FF7B38E78',
  '0x42b10b337A5692743D587134c89A725422c3dFFB',

  '0xf93AAAEC5e4ceD8605A57B3dfF011eC408A8EbDB',

  '0x3769ab981F7F4572Fa2C0032de2C010364DF9999',

  '0xAE32841ba13B1880DC7bbfE75E6A29f1AB08ea87',
  '0x7729E5815f0cd01615735fc50Cf9CE779a267487',
  '0x93ea91f5E00026C4EDf3f2C94b0C1C202966387C',
  '0x89eB534E60cF13377EADa52E30E1fd725a372b3C',
  '0x1A8dcfDACec6FdbE092e63B57C6EC3608D2b4095',
  '0x8183241fB35b3567553eF421F924e4cA65cf963a',
  '0x0Ac7fbd8180921c586b54d6c4D9f0a0D3E3A1140',
  '0xf4f21009C139875D5Fcff6f3889D53798D5f3fF4',
  '0x6A87E2cd600B975d9ba57450f15368fFC76b3530',
  '0x21C33850c4F4C97f148fBc4c92D3d9B93009F2e3',

  '0xb8E9f05beA1d82e1E4Aa79DD60D9065d1Bc0cAcC',


  '0x7e187675111bfb80AFc7607d2E747AE42c45Ef66',
  '0x5c381ab5e49dE584E5aA4190086022F0CEeb445C',
  '0x7DBD6FD7D20f29135f34dFb9c4dE69F326Ef68D5',
  '0x7C215243570F737FdbcEEBD456f72375BD7b3eee',
  '0xA49fB28Ab9Ac91Aa605bFef047A2e5A12155A29e',
  '0xCDa0F9Ac7b87DDAc570106376c6e774fbD479552',
  '0x300133b7FBE4DC2f10d3546fAc9666b6598e94FE',
  '0x41DA2397b493fD5fCf8EB9F81c1BA838D9DA6563',
  '0x83D1684Ad73a597F9d9B5BfEA2A47d7754F5b3d8',
  '0xf0a8ca8bFf57103a8D0c8Ed69Cf64151BeFA0752',
  '0xC73ab8B0a3DA031D7FaA00ca75018E4976960303',
  '0xa4251fE65a3431E77267896587CAAD0Bd379E88e',
  '0x3128E9f87924DB85A952850e34f3D6694385eD8d',
  '0x703cbA23e8d80328A928AF9f32A6c53ACe61772d',
  '0xf9BE8Af9F649113a10529526e4c4dbe0f1F90289',
  '0xc130ED78bB8c56Ac82aeA2216c8F2A49b94Ad52f',
  '0x4b4731Ef80BAC70101425d6f5dCfbe11520B1639',
  '0x75fDA11C7dDFe148EaaC0623Da2CE7447Bb922bc',
  
  '0x3f34BcC0a196A2e74417E97ce77c334948B44fA5',
  '0xf509d20B2492Afdb2a618593390a5c863Fe1d888',
  '0x539E1d99DF1EB703b49E4C91bFB3EBd159B06d99',
  '0xF593a43D28F8cf26B00912925d590942bA63b1cc',
  '0x859DA254C30504bc3042A88269Dd0a247F36FAF0',

  '0x3BE5c2698D245f6AFe3AedC78183EcF24D13F765',
  '0x18677585f024A5f93Cf17808313168603f6Dc8a4',
  '0x2f010FE05B35b85F52e2a7F0D9478cD552960b1f',
  '0x71E89867d5Ae324e2848e7e53578f407b1e7A65e',
  '0x80572C8FCdE67C6050099deD81a6f5Ed87b2B77F',
  '0xA27Dd3e4D9657a3670C1B3254bbFbd703CCb40b4',
  '0x5c7E0842797730c64348264bF4AC11A36bcF4aF0',
  '0x0d3c14AEEAcBC192CAB082851D74E71E4420FEeb',
  '0x03EbAc2D81A569a024c7D72b27aa25297184ac96',
  '0x038462765e259fa796398131E135436F812A3ed7',
  '0x480fDAC187f65a80D2559f2BDf7f5db9B8E36D2a',
  '0x9d0442c647d42C09F18A46AC0f4337889A16F749',
  '0x798793f71D3f940613C2fea9f58f2D4dE54143D0',
  '0xD3cDb73f8Ae4A777c136020ee4318c6EBCE24d6b',
  '0x831CFc8E4D4FBd35ECf2457823e5964010fa6cB3',
  '0xA05333138ca34F6Ad98992bD5074AA94d5E87a0C',
  '0xDae920ff12608CFF2C13882251Aed41A8a9A7fDF',
  '0x5c7E0842797730c64348264bF4AC11A36bcF4aF0',
  '0x580146a0CA29680B83E0FF6340d3dD7C1D5b8d13',
  '0x42f722A8259105650c11c9b62b5F949B4bb82248',
  '0x1E9B6cd416527649A4004a333Bc86C14A9FD3dbA',
  '0x5829B8aA87503ee3Ab45F202BF1566cdd9345B83',
  '0x4B74f14162f901FE643F0343BBa26d015f063006',
  '0xE1Ce8D85C85674DC88Be5173df9678A5E89ab2DE',
  '0x93ea91f5E00026C4EDf3f2C94b0C1C202966387C',
  '0xe359A42935a053cC3891AeC377aa35F2564eB30b',
  
  '0xCD31BA0842B9FDd628CA334ABAF0Cb03ec01d333',

  '0xdc572d7AD2f6121AF3A35a49B2133A6d3b8B7c17',
  '0xDc6BDe1D6c33FFa3B817771a9F5dFd275FD62882',
  '0xa1817dd1eF89e58D41034e018B14f2EE161Eb657',
  '0x109889f5cd16d0c619EFAecB987aB7B883fF3Fa4',
  '0xcD8F4A1eb1085F9550cCd1165b611eF81853F131',
  '0x03e6E1007A880828F7c488EB13FB06F939Afb333',
  '0xa6A85D37112290F7C60b156A64d8E426d9eAd89d',
  '0x9bF68A0f0be9A9B6dCeb4D5675745c2f7cFb9483',


  '0xcc80040DA356Df6F969Ca3383A3a57aE43A6208B',
  '0x0218d20cF0b794442128eec78fDBA2C359A41834',
  '0xEc1A4726B21DCbFA38CbB9706fE6571B931a5c8D',
  '0x4A1158353B1C279788eb18f16C5DDc7699Ee7e46',
  '0xB584cE767E5a9Be5d15238EdfC6821eab9697181',
  '0xe22D639016d618b5C3dD13bB7c68F6B1ADEd5E3E',
  '0x8D4b951B581dB6010BDAa7Fdf14c1aa01d560EA8',
  '0xa2D35E418814A8b6367c66a5ac2FEc8ea16332b2',
  '0xA8bB2e8898192852a08e52f504aee6E1378D4151',
  '0xbE53aC9178cDE328cb52e70882a1b24Eb1734481',

  '0xd9a62C288a50c5940b82038A2BD555bfbf6309C7',
  '0x8E8bBB0283DD62A2d40B4f1310C0E57d1927e140',
  '0x0A72E8fb75146354E11835e6b8957923c6f82bc8',
  '0xd6d191dF0B909460bA5c0611F8e67A68748F5f7F',
  '0x1F8DeD4F1A82a64641ac9C15BAa4e06Bd8ae740E',
  '0x9Cac5110E5aBB489B57BeCB84A1Ee84e3cd47401',
  '0x422fC6d98BfC720BE3B9c594a324dbdcE79C9967',
  '0x32De038A5Ad9845Fc6D077F73A85cc9C61115314',
  '0x9e09d3D84E48552Ae7B19F72843F580d63a005FF',


  '0x79853f6eF751667F42fb8fC83363ea666B4a7224',
'0x156f04Af1a796d1B9FCA58B5112722d0DE0f347f',
'0xE2522b564B92dDc5aA2cD7197167D85d9E1189d1',
'0x86f633812d1Ee85aB6A7E753B4553995e8c0C10B',
'0xb26B4c8269448029cC6b8CaBf189285536560Fa1',
'0x1ebbD94357e451850DEaA65D1e8c9396b14B6a37',
'0x4346E7F6c37dEaFB3B7a563b0Cfdfe5C3bc82184',
'0x5b9D87ee22bCdB34793A5d6b1fA254353d59fC75',


'0xb455465e2F3CeBaB9075d4Fe0e036f86a734B99d',
'0xc413487d3720fD86E913B34BceFfE72d9a1823B3',
'0xd9A4a7031e16AD072bE2F4bdd182726d1c14919C',
'0x690E93774B0E27c942E9A7BEb12D019519d8bC9a',
'0xAbE82cEdDc9870cF2bb7a30114e5F74f444011ee',
'0x827De172eEe1fecC774cEe97d24d4FC76c504B49',
'0x962FbB30808E2DD7b8DF8A081c720Eb7f5098809',


'0x3797D0746f306ba6E6d2442E35ebf067006b0a15',
'0xb9c073281C8771d88105eC6f232CD745d2D32aCe',
'0x3811D1B73EEfD6CC5CE73A052BcfEf5671C1E602',
'0xA1e252C2e45809DBA8163cf8dbFC9D971b2ed7b9',
'0xe1CdF1fe61d79CaC718D59d9e90c00424de17B11',
'0x55BC5E6Ad29DA823854822749FD2Eda2775C78bd',
'0x74ed0600e4b5c8d97eb32Fc44C5A57A2aEe49e69',


'0x50b5d4768efb012150ab4c24c39924b14acbb9ce',
'0x6e13F592337cACBf561A3e92EC5A6911409d7588',
'0x18a44196C6f5Ac90e3e1605C564EAC2d1F86216D',
'0xE1373517e89960C43a74D5Fa7d53Eb0Ec0c9A654',
'0xEa9bFC911CEE9c378dfc46E50E5dB2CaAe56d689',
'0x382827268EfD1a65e391F058CdcA9c082A3B9Df2',
'0x07a9732Ef4435338e1FE98aFe26B4Cad679b56CD',
'0xEF92F0BC120eEF4C2A0C40691CF10825c152817c',

'0x85F1e35F1345bb4CC388873593D789359a24cb8A',
'0x6aC9a0B04BAF70F2F6F6566fD17Bcaec0Cf764Da',
'0xAD64Bf3DbCC9A447fEb81F82594C12054F4C75Bf',
'0x80572C8FCdE67C6050099deD81a6f5Ed87b2B77F',



'0xE97C72D6448c7565a0038cD6284865F8Ab22Df3d',
'0x325F3f56767b7eabaf804F247FA90e3454789c37',
'0x23a744f2db0cede529ff360c387a1eb818ec2d64',
'0xA8169bfFCFc29643781d5d2d0d10cC7fD66ae377',
'0x52c635F0C85F2B40F8206a5afCa7EC7091B945B9',
'0x5E53BEd9ECFA96f44086C68D210E7DF0cEBE2CB0',
'0xEcb2362D68B1b4EB6b54bC8a3B686fCE5c130130',
'0xF00D9838c0b9528CaA13220B46170A5Ac4f59704',
'0xd76EAd6b28824BA5C66a96e307Da3363b1bbfCCF',
'0x799f0b8C7656a8396A006c2c3584dd12aECB847f',
'0xd08889CDA6c09680F9B4C6BADCB102Cb4AB423E8',

'0x3F25f67ddA0b1f2C287567F22be6157Ce84EAe74',
'0x0E64e205423F952af327800790669178A262D454',
'0xdf54Ea86d1AcAe29C3400672591cB825D1Bb999f',
'0xeB2E714Ee71Eb06570201Fe1c960fBB92fEa6255',
'0xaC9614d8f09810e9635b2Be8454431C0ea4fd2Fa',
'0xFeC1E8863a700A0EebF9ACFa2F8eb04B6E08e064',

'0xC4a260A4E439860A5E9d18C14146c03f5D01e736',
'0x11B958700c621cA184C519607f5c90c8492B6C72',
'0x4C8392E958e4e728AE17b0D9b2C931419C9396D9',


'0xf219d56a80eDe4eB16040442F2De6af932B70E45',
'0x63d0CfEb56C30a8c72Fc64E6e7f12C340985a975',
'0x35Db86F3c27649CB19bE0cfbD701A3Daa589F022',
'0x5618d05d31A813BdaFf1df4BB945eC729394E057',
'0xcc6E3eCCA96407175AFd9351c2660d940Db749cA',
'0x12db97A9C4FD14C1ca980950052939d467269F4b',
'0x58EC77016681cD43Ea9DFf778FcCee9168eAc9c9',
'0x58c430e454353218C3a71d2784937c45A541d431',
'0x4113507198B6384Bb90c381BCDA7a6034e65CAbd',
'0x4097F588771A9eCCfF410E78C454533b1492E43C',
'0xc1745ab50D6f114393Cba62cBb15d1543dBC77C3',


'0xfEa5c40cBD1Af30f0981604Fd3e17Fcc1F7a644C',
'0x5E8675FBCcb9561963e76504Ef567303106EB4E2',
'0xe2aC0fc8d6E1041BdDd90BD1C2156785bb5dcf4D',
'0x4531ABE5939cc122c7f47D0357F4393745E9925c',

'0xC17e344C1B259AC7479c7Cc3c5BD0856f17FF5F0',
'0x6030A723b3847b35ee48B88C524c56DB7fd0C7bd',
'0x2E25E92fA55b2A7C10c0364e5886Ef162A979937',
'0xaD80BB59B0d21EBC70e9e3268518eD834C20c7E2',
'0x31aa83927925Aa19ff1E60B724912704d652F65F',
'0xBc3dBdBA9695e7ea05eb38e9B797b5aDDd3074d1',
'0x9d386d2D8413A9c3781Af9148d07cDb196E3C726',
'0x1C48738Dd0c58193637eA7592b57f158b1f867D4',
'0xC369628e099cc545Eec195e8B7107F5c4aba572c',
'0xF186a7d026FFfB7Abbb0923Fb0622DA294A6a5dd',
'0xfA629be19666D5d22939E4CA7d433086A101243E',
'0x915D235f0017257C0D3f4Dd85a50c7bf963BB360',
'0xd0A670FB2c844033Ed3D019B2E3D698B27Fa7082',
'0x4C6ef70bF0Baf9F264696dd14720e5dbF2EbA4C6',
'0x7f7605eF5bB9e89de0365ef508a5Bd21C18A8bc9',
'0x7a9c3B1aeb07C8E32e852879a4049d031FA933f2',
'0xBf45819611A26F4E90c93cA88a393cC6Da81699d',
'0xbBC3324B3dE7c2ce2680DAe380b2E19fC6e54658',
'0x999C0761b400c3226EF8167016B4d326Fa342824',
'0x1a09E9B6D2588262f24174C50BAb1452fC9a0Cdc',
'0x6Fb4144dc1C10c27e29ea446bD7f129c9DB8E923',
'0x1e55D5c09bEb9F97e55809E5a9a00f209fdF3671',
'0x1C7c7b93F7D17a0FaaBfe6f99557C89493CcB9e4',
'0xBA83C465884a2d1A2309ABeaD098320832acc243',



'0xEBB151848e820e3c884a5687bE6c802C4d7cd38F',
'0x34a430efd0E562a946fCC3324e23B359f97515De',
'0x3007b29381d3543F3743AfeC9a38e27BC729d65a',
'0x3B9088F33DD1418EDDcD90E6a1D6d0Df1054Dc87',
'0x6898e8B1ef48801D7d6122d90fEA2Df5b2b71d05',



'0x447Ed7a3e5b4E5096FD81E10eC6DF5F8cdA5bA60',
'0x68Ea25e8eb56132b6E1381E96441Ad3982d5c9D0',
'0xd13F886325639372a83ece4936654592d79056f7',

'0xb704061A9F2AC19Ec811cb7A887CBA6803d9f5c5',
'0x2Cd91356c9b976357fF8EF128e5c236E1d748186',
'0xf801f754aB8A12e5e2A668b142F7b808b79162fc',

'0xbb5982361cf3054d70a4003ef074695ba45cdc24',
'0x28E821a1Afdb463ad7a9BdEBFDC1d421128Cd08b',


'0x604193C8a9762F359d97fee66D72ba3a827b575d',

'0xeAC9fd96D3Fb77156Ea33AEa6A49c22f21fb802D',
'0x94461AFe69ae364B45bE578AeCFA3c7a2A6FE5Dd',
'0x1B0f50d7e86d810b6F67e2BFef892ef3F4E3B821',
'0x63577E7034eEeC4446FDCB58a547bda878ebF33b',


'0x2D07b7eb70e1ca8a9A645a4ea2a0753041E99a3B',
'0x56fA0d9C5843a3CE2886d7251793812c7519Cc61',


'0xE8576daE123202c091d0Ca4ECE2cBDf3F175c62e',
'0xb39FA0350D3912BCF5bf591C7d930C0640Ba366B',
'0xDF49fCFD5E1764EcDee8C5f54801959041E61414',
'0xf035aa5E53afF86Bdd51cbD3e6Aa9feE67714446',


'0xa13dD1BCACaa2728932358CBfB85873EC27fE44d',
'0xa24C908cccba2869bB88768014D798b362510149',
'0xa3809D2d7B2F5a686d836B607e691db6d8BE8662',
'0xa4e62cEc2EcDbc718AA681810f7a016f2F52A9b8',
'0xa53A5ECB7394D0f91b6dEb49F6D7f4d7A40C004A',
'0xa6C7A9F3D6D8cB31F5f3DE72dd77E3F3bD3CeB2F',
'0xa78205C435e0c97F863d9bfa825B71C9971e63e7',
'0xa807a49137b0d0D012052c5301f9624967298C06',
'0xa9cb130B694ef6450d8460AfC1B32Fa6a49E563D',
'0x1d5603071B3a2C68C6Fed879eFAE6F9Ae4db84a4',
'0x1A8dcfDACec6FdbE092e63B57C6EC3608D2b4095',

'0xeE8C45dc8D1510Dd6C014D6549B3023b3760CED3',
'0x83eE33564EA39Cc2152baD87F1D0d464D07FA3aB',

'0x9614eDcB6f53D11396A148E6C93dBd0FdE9931FD',


'0x0e2B80e558CF0aa79F65fe2625A46821E46d5CC6',
'0x7cfC1a3C0E80749E0b771c56d61B7C7Eb9c46Bf4',
'0xD46151D7c0753a7399232e0115a7098cc4039302',
'0xbAc9E1Da19FF794Cf1037eC332558C7987C6c506',
'0x096051f3879D7b749Aa682AA2237bc877433a6ea',


'0xF4E4B3C8F2fdF9fFd83B7EeF334D6BEa1127DB9E',
'0x357361832C293E35141C205e500C6545ed014a22',
'0xdddF5c10590052EB273e20883C07a3f24b840142',
'0xFDd96c34fB9e6703D440f0Da7a1e35C90D51566d',
'0x053A3da16C24B167fDE9b74C4241F1BCAAbe81cb',
'0x3Dc0F71C448154Ff8B2572Ec812964eD2A58Ed3A',
'0xcE4c54D3e616DBdCAE23EAa8E0Feeb6de9144A49',
'0x91c07403517346a1e4aB52914F39C7F0dbA870B4',
'0x6fE9994275D536c182C56393A276C24D07444048',
'0x822540b0E85635b3643b7784F7CcE32BF08Ff2A5',
'0x1624fc88143b22A0B338303F57bF27b8AB568257',

'0x9d0442c647d42C09F18A46AC0f4337889A16F749',
'0x76f805ffebaD277691f2f4a3e421a71d35Be6F18',



'0xbe4434DA6ffCdc79eBaBCa599e30225dE0c54FD9',
'0x9421244d1c4d991F41adD4314Bc14D9370fDD2a2',
'0x962507e4453300B122b83e2e69cE79EB1A4e03E6',
'0x49389fc94cd5ee75055AbA5ac31B4DbeD577B9D7',
'0xe59FAe478E9C5c50D4eaF5f54e56a85c9B5d8755',
'0x40f9ee0CF1a83514B441A8E0B20335187DdC4d8D',
'0x40Fc34B96d96CCd3a1BDF5D3e4bEBdF70F9C5f3B',
'0x4a011A880E69ED7EbDfDf294790a603792c79998',
'0xE8B96200B1a5457b9DdA7dD9Ff2BD6EE834D823A',

'0xDF03D0ad509e5bD03DfafAC3A1cEC923AC67B099',
'0xd76c72551dF78318Fcbe0Dd9E816bFf4B113eE1b',
'0x110C302D08a0Cf8D071d515cA66725d913ba345c',
'0x4626c59C5753C7D02119d918a1060b8D45f828f1',
'0xBCc9A7B12531f42958049218252eD0d134adAA3c',
'0x5cB9a69782064e6276da08FA2f37967d66DBFf79',
'0xD85fD213Ca3A80A31B3D77E201Dc9Da07470E394',
'0xBc2FfFE6ea61f90A775075B7deC2FA81B4907300',
'0xb233289FC133dC4E9f2FD86C205d31161B625BCB',


'0x6C736AA7621DF5b61FBDF3f5db843b2Ea2c66A29',
'0x0eF336003b1d90DA0977523E0CaE81EFdC5A5548',
'0xC2A3Fa5a0B2e059e5A42F1CCf1e0F08b866780F7',

'0xcDEbe893CC4D30E1825F498c177DbF6AdeBe87Df',
'0xc27b823c17797573000f14086f46df268cca2d01',
'0xC2A3Fa5a0B2e059e5A42F1CCf1e0F08b866780F7',
'0x4295B6F551db767fA3144d306D3C65Ad314d9C3c',

'0xc78Fc89206599748B4033303971bBDFbd515AA5C',
'0x4583707F98B1Ad1298f2daC9930f6558dA1eDb68',
'0x80a5016d1bb821eD18d5D1D6389a16925c170086',
'0x4E3f7e4934E7986FF2087E75bcc33846619bAeDd',
'0xA6a239558E4248D490935C99Fd010f369CCa8028',
'0xd2d7d2b031B99Ba5aBac48A2410Ea232c5Cf4FF2',
'0x280C487f9A8c1E4a39D9F9A6663F9662d1Ad9be7',
'0x3f2D9EdcFE980857a08e8aFaA1eBc5B45b50F2A7',

'0xC2A3Fa5a0B2e059e5A42F1CCf1e0F08b866780F7',
'0x39d86cca08eB062566C65bcc58eE3cfc412ea905',
'0x6e13F592337cACBf561A3e92EC5A6911409d7588',


'0x18677585f024A5f93Cf17808313168603f6Dc8a4',
'0x9a1654a15ccd68D04b353C7EA8d5791A9316c2F6',
'0x1C6aD3A22a8f40A00a106Ad81B885519BbF43CED',

'0x8D54A631212BcE56Cb55Dc6de861348e3B14Be44',
'0x16Fc26A2b7Ef6390D2591eAfc7C61FD842b98c22',
'0x01caF993f2961F6d199CA62119AAE71D99Eb6ec1',
'0x1276cf37FeEDAb33163d64296113d7565Fc3a1dc',
'0xC43d205a2079B9393Ae2dcD0B2Ac5F1b1564d31f',

'0xB3C408039f3Ec0e3762C2909427b2bE7856640d4',

'0x0292Dabcc1f29636C0dD023fAfD4173f1EDA10F5',
'0x0241C4fBd5AF5E7047E8ecC80cEdB438F69f81B0',
'0xBe6b6194696A72fC68f97FEC4793F865603C27C1',
'0x623d2ac92e172bf9Cc855C39138e5EEdc78684DA',
'0xcdAB76A378f5311E4fC3b987DC0FB02f69F6FDC5',
'0xAb59D48c999b7266CB193d04e3E0bF4825736Ec6',
'0xdA3EAB798AA071e40e997170317b2c70af857C43',
'0x079EA5AC81E35CAeE79916DE02825f9df05243F4',
'0x0d6468C51C16cd52840E77C3Bfe3717f0012e852',
'0x867b284523c71a52C56C3034543079665C5aC69a',


'0x6177312EbFE9a6B26D66de4E6772F8e7d38157E8',

'0x26fcBA32F51246BB0e6764601293811Cc3DCfE17',

'0xaE535680e66582CACaeA7eA3dbBf3049bEf50aF2',

'0x3B34759bAa3a24Fc91362453020C438a8DF0b345',

'0x338c0A7d74bD05dcdE40676cAF927726b8a9e507',

'0xca354b763ADA7eE8F840fB82485Ba052708A6546',


'0xc63d7945Bf15A7FC176B5dCb068fB6774fD36c35',
'0xAe7c03223BeE44aDE03CbDC5845045131EAC276d',
'0xB0E586d57846eF1Ac74D9d62Eb1e21DCBE949729',

'0x2A92dc34517A17B62eBc32760E8F9c475d93f241',



'0x7a4DD150423A7722B6526D2BD278EABFbc345128',
'0x95b5e17c7068B5634274DE9841373df41Ff7e567',
'0xB2A08414C48B92295d180d3d1429BFdbfd0Afa0A',
'0x2F7394D937Eb4b24EeAc2B508955c54d5C136462',
'0xC8420d8ed05dC81D0FA71622fA7fa8202E86A433',
'0x99770995e85d15a209fD30E07053e47216BdFCe6',
'0xE56B3CA20c3B8B411E3CA8C2732af8b002FfF5B6',
'0x32923756bBEa676A8E2765e5293015853110A5Ff'
]